import { useEffect, useState } from 'react'

const getMobileDetect = userAgent => {
  const isAndroid = () => Boolean(userAgent.match(/Android/i))
  const isIos = () => Boolean(userAgent.match(/iPhone|iPad|iPod/i))
  const isOpera = () => Boolean(userAgent.match(/Opera Mini/i))
  const isWindows = () => Boolean(userAgent.match(/IEMobile/i))
  // const isSSR = () => Boolean(userAgent.match(/SSR/i))
  const isMobile = () => Boolean(isAndroid() || isIos() || isOpera() || isWindows())
  // const isDesktop = () => Boolean(!isMobile() && !isSSR())
  return {
    isMobile,
    // isDesktop,
    // isAndroid,
    // isIos,
    // isSSR,
  }
}

export const useMobileDetect = () => {
  const [width, setWidth] = useState(0)

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth)
    }

    window.addEventListener('resize', handleResize)

    handleResize()

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const userAgent = typeof navigator === 'undefined' ? 'SSR' : navigator.userAgent

  const { isMobile } = getMobileDetect(userAgent)

  const isMobileSize = isMobile() && width <= 425
  const isTabletSize = isMobile() && width <= 768

  return { isMobile: isMobileSize, isTablet: isTabletSize }
}
